// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressToJSON,
    ClaimEligibilityItem,
    ClaimEligibilityItemFromJSON,
    ClaimEligibilityItemToJSON,
    ClaimEligibilityValidation,
    ClaimEligibilityValidationFromJSON,
    ClaimEligibilityValidationToJSON,
    ProviderClaimEligibilityDependent,
    ProviderClaimEligibilityDependentFromJSON,
    ProviderClaimEligibilityDependentToJSON,
    SexType,
    SexTypeFromJSON,
    SexTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderClaimEligibility
 */
export interface ProviderClaimEligibility {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    id?: string;
    /**
     * The information source name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    informationSourceName?: string;
    /**
     * The first name of the subscriber
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    first?: string;
    /**
     * The middle name of the subscriber
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    middle?: string;
    /**
     * The last name of the subscriber
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    last?: string;
    /**
     * 
     * OpenAPI data type: {Address}
     * @type {Address}
     * @memberof ProviderClaimEligibility
     */
    address?: Address;
    /**
     * The date of birth of the subscriber
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderClaimEligibility
     */
    dob?: string;
    /**
     * 
     * OpenAPI data type: {SexType}
     * @type {SexType}
     * @memberof ProviderClaimEligibility
     */
    sex?: SexType;
    /**
     * The member plan id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    planId?: string;
    /**
     * The member plan description
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    planDescription?: string;
    /**
     * The member group id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    groupId?: string;
    /**
     * The member group description
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    groupDescription?: string;
    /**
     * The member other qualifier id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    otherQualifierId?: string;
    /**
     * The member other id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    otherId?: string;
    /**
     * The member other description
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderClaimEligibility
     */
    otherDescription?: string;
    /**
     * The plan start date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderClaimEligibility
     */
    planStartDate?: string;
    /**
     * The plan end date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderClaimEligibility
     */
    planEndDate?: string;
    /**
     * Eligibility validation information
     * OpenAPI data type: {array}
     * @type {Array<ClaimEligibilityValidation>}
     * @memberof ProviderClaimEligibility
     */
    validations?: Array<ClaimEligibilityValidation>;
    /**
     * Eligibility item information
     * OpenAPI data type: {array}
     * @type {Array<ClaimEligibilityItem>}
     * @memberof ProviderClaimEligibility
     */
    items?: Array<ClaimEligibilityItem>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderClaimEligibilityDependent>}
     * @memberof ProviderClaimEligibility
     */
    dependents?: Array<ProviderClaimEligibilityDependent>;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderClaimEligibility
     */
    created?: string;
}

export function ProviderClaimEligibilityFromJSON(json: any): ProviderClaimEligibility {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'informationSourceName': !exists(json, 'informationSourceName') ? undefined : json['informationSourceName'],
            'first': !exists(json, 'first') ? undefined : json['first'],
            'middle': !exists(json, 'middle') ? undefined : json['middle'],
            'last': !exists(json, 'last') ? undefined : json['last'],
            'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
            'dob': !exists(json, 'dob') ? undefined : json['dob'],
            'sex': !exists(json, 'sex') ? undefined : SexTypeFromJSON(json['sex']),
            'planId': !exists(json, 'planId') ? undefined : json['planId'],
            'planDescription': !exists(json, 'planDescription') ? undefined : json['planDescription'],
            'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
            'groupDescription': !exists(json, 'groupDescription') ? undefined : json['groupDescription'],
            'otherQualifierId': !exists(json, 'otherQualifierId') ? undefined : json['otherQualifierId'],
            'otherId': !exists(json, 'otherId') ? undefined : json['otherId'],
            'otherDescription': !exists(json, 'otherDescription') ? undefined : json['otherDescription'],
            'planStartDate': !exists(json, 'planStartDate') ? undefined : json['planStartDate'],
            'planEndDate': !exists(json, 'planEndDate') ? undefined : json['planEndDate'],
            'validations': !exists(json, 'validations') ? undefined : (json['validations'] as Array<any>).map(ClaimEligibilityValidationFromJSON),
            'items': !exists(json, 'items') ? undefined : (json['items'] as Array<any>).map(ClaimEligibilityItemFromJSON),
            'dependents': !exists(json, 'dependents') ? undefined : (json['dependents'] as Array<any>).map(ProviderClaimEligibilityDependentFromJSON),
            'created': !exists(json, 'created') ? undefined : json['created'],
    };

}

export function ProviderClaimEligibilityToForm(value?: ProviderClaimEligibility): any {
    let jsonVal = ProviderClaimEligibilityToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderClaimEligibilityToJSON(value?: ProviderClaimEligibility): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'informationSourceName': cleanupBlankValuesForBackend(value.informationSourceName),
            'first': cleanupBlankValuesForBackend(value.first),
            'middle': cleanupBlankValuesForBackend(value.middle),
            'last': cleanupBlankValuesForBackend(value.last),
            'address': AddressToJSON(value.address),
            'dob': cleanupBlankValuesForBackend(value.dob),
            'sex': SexTypeToJSON(value.sex),
            'planId': cleanupBlankValuesForBackend(value.planId),
            'planDescription': cleanupBlankValuesForBackend(value.planDescription),
            'groupId': cleanupBlankValuesForBackend(value.groupId),
            'groupDescription': cleanupBlankValuesForBackend(value.groupDescription),
            'otherQualifierId': cleanupBlankValuesForBackend(value.otherQualifierId),
            'otherId': cleanupBlankValuesForBackend(value.otherId),
            'otherDescription': cleanupBlankValuesForBackend(value.otherDescription),
            'planStartDate': cleanupBlankValuesForBackend(value.planStartDate),
            'planEndDate': cleanupBlankValuesForBackend(value.planEndDate),
            'validations': (value.validations === undefined || value.validations === null) ? undefined : (value.validations as Array<any>).map(ClaimEligibilityValidationToJSON),
            'items': (value.items === undefined || value.items === null) ? undefined : (value.items as Array<any>).map(ClaimEligibilityItemToJSON),
            'dependents': (value.dependents === undefined || value.dependents === null) ? undefined : (value.dependents as Array<any>).map(ProviderClaimEligibilityDependentToJSON),
            'created': cleanupBlankValuesForBackend(value.created),
    };
}


